import { render, staticRenderFns } from "./keanggotaan.vue?vue&type=template&id=f48ea05a&"
import script from "./keanggotaan.vue?vue&type=script&lang=js&"
export * from "./keanggotaan.vue?vue&type=script&lang=js&"
import style0 from "./keanggotaan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports